<template>
  <div class="jftdetail">
    <XR-head titleText="交易明细" :rightShow="false"></XR-head>
    <div class="detail-traceAmt" v-if="!loaded">
        <span class="amt">{{getOperater(streamDetailInfo)+streamDetailInfo.TraceAmt.toFixed(4)}}</span>
    </div>
    <div class="row-list" v-if="!loaded">                      
      <div class="row-item">
          <p class="item-title">交易单号</p>
          <p class="item-value">{{streamDetailInfo.TraceNo}}</p>
      </div>
      <div class="row-item">
          <p class="item-title">交易类型</p>
          <p class="item-value">{{streamDetailInfo.TraceTypeName}}</p>
      </div>
      <div class="row-item">
          <p class="item-title">交易时间</p>
          <p class="item-value">{{streamDetailInfo.AddTime.replace('T',' ')}}</p>
      </div>
      <div class="row-item">
          <p class="item-title">备注</p>
          <p class="item-value">{{streamDetailInfo.Remark}}</p>
      </div>
    </div>
    <XR-toast  ref="XRtoast"></XR-toast>
  </div>
</template>

<script>
export default {
  data() {
    return {
        loaded:true,        
        streamDetailInfo :{
            CreateTime:"",
            CreateTimeName:'',
            Description:"",
            InOrOut:0,
            PlusMinus:"-",
            TraceNo:"",
            TraceNoName:'',
            TraceType:"",
            TraceTypeName:"",
            Trace_Amt:0
        }
    };
  },
  mounted: function(){
    this.$refs.XRtoast.load()
    if(this.$route.query.traceNo){
        this.getDetailInfo()
    }
  },
  methods: {
    getDetailInfo: function() {
      var ths = this;   
      ths.$post(
        "/Shop/JftServer/GetJftStream",
        JSON.stringify({'traceNo': ths.$route.query.traceNo})
      ).then(function(res) {
        if(!res.IsSuccess){
          if(res.TypeId == ErrorCode.SessionMissing){
            ths.$router.push("/Login")
          }
        }else{          
          ths.$refs.XRtoast.hide()
          ths.streamDetailInfo = res.Data;
          ths.loaded= false
        }
      });
    },    
    getOperater(traceItem){
      if(traceItem.TraceType == 3){
        return '-'
      }
      else if(traceItem.TraceType == 4){
        return '+'
      }
      else if(traceItem.TraceType == 5){
        return '+'
      }
      else{
        return ''
      }
    }
  }
};
</script>
<style>
*{
  margin: 0;
  padding: 0;
}
#app .jftdetail{
    background: white;
}
.jftdetail .detail-traceAmt {
    overflow:hidden;
    text-align:center;
    margin: 0 20px;
    border-bottom:1px solid #efefef;
    padding:35px 0 35px;
}
    .jftdetail .detail-traceAmt .amt {
        font-size:30px;
    }
    .jftdetail .detail-traceAmt .unit {
        font-size:12px;
        color:#aaa;
    }
.jftdetail .row-list {
    margin: 0 20px;
    padding:30px 0;
}
   .jftdetail  .row-list .row-item {
        padding:10px 0;
    }
      .jftdetail   .row-list .row-item .item-title {
            color:#ccc;
            font-size:16px;
        }
       .jftdetail  .row-list .row-item .item-value {
            font-size:12px;
            padding-top:2px;
            word-break: break-all;
        }
    .jftdetail .row-list.last {
        border: none;
    }
</style>



// WEBPACK FOOTER //
// src/pages/usercenter/jft/local/jftDetail.vue